import { render } from "./DeviceTypePage.vue?vue&type=template&id=1a9c820c&scoped=true"
import script from "./DeviceTypePage.vue?vue&type=script&lang=js"
export * from "./DeviceTypePage.vue?vue&type=script&lang=js"

import "./DeviceTypePage.vue?vue&type=style&index=0&id=1a9c820c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a9c820c"]])

export default __exports__